export default function renewalsReducer(
    state: any = {
        renewals: {
            loading: false,
            done: false,
            response: null,
            error: null,
            success: null,
        },
        renewAsIs: {
            loading: false,
            done: false,
            response: null,
            error: null,
            success: null,
        },
        renewPolicy: {
            loading: false,
            done: false,
            response: null,
            error: null,
            success: null,
        },
        lapseRenewal: {
            loading: false,
            done: false,
            response: null,
            error: null,
            success: null,
        },
    },
    action: any) {

    switch (action.type) {

        /**
         *     Renewals list reducer
         */
        case 'FETCH_RENEWALS_LIST_PENDING': {
            return { ...state, renewals: { ...state.renewals, loading: true, success: null } }
        }

        case 'FETCH_RENEWALS_LIST_REJECTED': {
            return {
                ...state, renewals: {
                    ...state.renewals,
                    done: true,
                    loading: false,

                    error: action.payload.error,
                    response: action.payload,
                    success: false,
                },
            }
        }

        case 'FETCH_RENEWALS_LIST_FULFILLED': {
            return {
                ...state, renewals: {
                    ...state.renewals,
                    loading: false,
                    done: true,
                    error: null,
                    response: action.payload,
                },
            }
        }

        /**
         *     Renew as is reducer
         */
        case 'FETCH_RENEW_AS_IS_PENDING': {
            return { ...state, renewAsIs: { ...state.renewAsIs, loading: true, success: null } }
        }

        case 'FETCH_RENEW_AS_IS_REJECTED': {
            return {
                ...state, renewAsIs: {
                    ...state.renewAsIs,
                    done: true,
                    loading: false,
                    error: action.payload.error,
                    response: action.payload,
                    success: false,
                },
            }
        }

        case 'FETCH_RENEW_AS_IS_FULFILLED': {
            return {
                ...state, renewAsIs: {
                    ...state.renewAsIs,
                    loading: false,
                    done: true,
                    error: null,
                    response: action.payload,
                },
            }
        }

        /**
         *     Renew as is renew policy reducer
         */
        case 'FETCH_RENEW_POLICY_PENDING': {
            return { ...state, renewPolicy: { ...state.renewPolicy, loading: true, success: null } }
        }

        case 'FETCH_RENEW_POLICY_REJECTED': {
            return {
                ...state, renewPolicy: {
                    ...state.renewPolicy,
                    done: true,
                    loading: false,
                    error: action.payload.error,
                    response: action.payload,
                    success: false,
                },
            }
        }

        case 'FETCH_RENEW_POLICY_FULFILLED': {
            return {
                ...state, renewPolicy: {
                    ...state.renewPolicy,
                    loading: false,
                    done: true,
                    error: null,
                    response: action.payload,
                },
            }
        }

        /**
         *     Lapse renewal reducer
         */
        case 'FETCH_LAPSE_RENEWAL_PENDING': {
            return { ...state, lapseRenewal: { ...state.lapseRenewal, loading: true, success: null } }
        }

        case 'FETCH_LAPSE_RENEWAL_REJECTED': {
            return {
                ...state, lapseRenewal: {
                    ...state.lapseRenewal,
                    done: true,
                    loading: false,
                    error: action.payload.error,
                    response: action.payload,
                    success: false,
                },
            }
        }

        case 'FETCH_LAPSE_RENEWAL_FULFILLED': {
            return {
                ...state, lapseRenewal: {
                    ...state.lapseRenewal,
                    loading: false,
                    done: true,
                    error: null,
                    response: action.payload,
                },
            }
        }

        /**
         *     Default
         */
        default: {
            return { ...state }
        }

    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/renewals.ts